import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// current User Details
export const currentUserDetails = createAsyncThunk(
  "users/currentUserDetails",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/users/me`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      // Check if the login is successful
      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during login.";
      return rejectWithValue(errorMessage);
    }
  }
);

// save a new user
export const saveNewUser = createAsyncThunk(
  "users/saveNewUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/register`,
        data
      );

      // Check if the login is successful
      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during login.";
      return rejectWithValue(errorMessage);
    }
  }
);

// get all the users --admin
export const getAllUsers = createAsyncThunk(
  "users/getAllUsers",
  async (data, { rejectWithValue }) => {
    try {

      console.log('getting data from getallusers')

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/users/admin`,
        data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
        // {
        //   headers: { Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY3NDQ3MjRiZWRjYjU5YjQ2NzMxM2FhYyIsInJlZnJlc2hUb2tlbiI6ImMyYTI1OThhOWE1MDUxMjAiLCJpYXQiOjE3MzI2MjcxMzYsImV4cCI6MTczMjcxMzUzNn0.--cyDg0YrNo75GztH0edknspRD40Cn9fCUVkbqcn4EM` },
        // }
      );

      // Check if the login is successful
      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during login.";
      return rejectWithValue(errorMessage);
    }
  }
);

// update a user  --admin
export const updateUser = createAsyncThunk(
  "users/updateUsers",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/users/admin/${data.id}`,
        data.data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during login.";
      return rejectWithValue(errorMessage);
    }
  }
);

// clear User System Address --admin
export const clearUserSystemAddress = createAsyncThunk(
  "users/clearUserSystemAddress",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/users/clear/address`,
        data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during login.";
      return rejectWithValue(errorMessage);
    }
  }
);

// block a user  --admin
export const blockUser = createAsyncThunk(
  "users/blockUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/users/admin/${data.id}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during login.";
      return rejectWithValue(errorMessage);
    }
  }
);

// get user count statics  --admin
export const getUserCountStatics = createAsyncThunk(
  "users/getUserCountStatics",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/users/counts`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during login.";
      return rejectWithValue(errorMessage);
    }
  }
);
